import { render, staticRenderFns } from "./LogoutFooter.vue?vue&type=template&id=5c8fa154&scoped=true&"
import script from "./LogoutFooter.vue?vue&type=script&lang=js&"
export * from "./LogoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./LogoutFooter.vue?vue&type=style&index=0&id=5c8fa154&prod&lang=css&"
import style1 from "./LogoutFooter.vue?vue&type=style&index=1&id=5c8fa154&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8fa154",
  null
  
)

export default component.exports